import { Vue } from "vue-property-decorator"
import { BLANK_TARGET, SELF_TARGET } from "@/constants/linkTargets"
import { UserSettings, ViewsOpeningOption } from "@/types/userSettings"

export const viewsRecordLinkTargetMixin = Vue.extend({
	computed: {
		/**
		 * Returns the appropriate link target based on user settings
		 * @returns "_blank" if user has configured to open in new tab, otherwise returns "_self"
		 */
		linkTarget (): string {
			const userSettings = this.$store.state.userSettings as UserSettings | null
			return (userSettings &&
				userSettings.settings.viewsOpening === ViewsOpeningOption.SameTab)
				? SELF_TARGET
				: BLANK_TARGET
		},

		// Export constants to make available in templates
		BLANK_TARGET (): string {
			return BLANK_TARGET
		},

		SELF_TARGET (): string {
			return SELF_TARGET
		}
	}
})
